import { AbstractCommand } from 'src/models/command';
import { Document } from 'src/models/document';

import { buildDocumentCategoriesCommandPayload } from 'src/util/document/documentCategorySelection';

interface DocumentDownloadLinkSettingsParameter {
	password: string;
	validUntil: string;
}

class ProcessDocumentCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_Document_ProcessDocument';

	public constructor(document: Document, downloadLink?: DocumentDownloadLinkSettingsParameter) {
		super();
		this.parameters = {
			aggregateId: document.aggregateId,
			aggregateVersion: document.aggregateVersion,
			buzzwords: document.buzzwords,
			categories: buildDocumentCategoriesCommandPayload(document.desktopPanelDocumentModelIdoCategories ?? []),
			filename: document.filename,
			postboxId: document.postboxId,
			timestamp: document.timestamp,
			title: document.title,
			...(downloadLink === undefined ? {} : { downloadLink: { ...downloadLink } }),
		};
	}
}

export { ProcessDocumentCommand };
export type { DocumentDownloadLinkSettingsParameter };
